import { render, staticRenderFns } from "./NotificationLogTable.vue?vue&type=template&id=8fc22178&scoped=true&"
import script from "./NotificationLogTable.vue?vue&type=script&lang=ts&"
export * from "./NotificationLogTable.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationLogTable.vue?vue&type=style&index=0&id=8fc22178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc22178",
  null
  
)

export default component.exports